import { MessagingOfferNotification } from "@/common/models/messagingNotification";
import { mapUrl, Client } from "../client";
import { Endpoint } from "../endpoint";
import { Controller } from "../controller";
import { CrmCallerContext } from "@/common/models/callSession";

export const fetchCurrentMessagingInvite =
	(): Promise<MessagingOfferNotification> => {
		const url = mapUrl(Controller.Messaging, Endpoint.CurrentInvite);
		return Client.instance.get(url);
	};

/**
 * Fetches the Salesforce caller context for a specific messaging session.
 * Backend returns 204 when the session has no SF context (lookup didn't match or SF
 * disabled) — the axios client surfaces that as undefined, which the picker treats as
 * "hide". A 403/404 means the agent isn't the assigned owner (or the session is gone).
 */
export const fetchMessagingCrmContext = (
	sessionId: string
): Promise<CrmCallerContext | undefined> => {
	const url = mapUrl(
		Controller.Messaging,
		sessionId,
		Endpoint.MessagingCrmContext
	);
	return Client.instance.get(url);
};

/**
 * Persists the agent's Salesforce case selection for a messaging session. Mirrors the
 * voice endpoint's contract — server validates IDs against the discovered set and
 * persists via Lua-CAS.
 */
export const setMessagingCrmSelectedCases = (
	sessionId: string,
	selectedCaseIds: string[]
): Promise<any> => {
	const url = mapUrl(
		Controller.Messaging,
		sessionId,
		Endpoint.MessagingSalesforceCases
	);
	return Client.instance.post(url, { selectedCaseIds });
};
